import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

import Translator, { __ } from "services/Translator";
import api from "services/api";
import { Modal } from "react-bootstrap";

export default function SeoContent(props) {
  const location = useLocation();
  const bringOnDesc = [
    {
      paragraph:
        "Step into the excitement at Latam1 and enjoy a world of exclusive perks! Every week, join our thrilling slot tournaments and race for stunning prizes. The top 10 most active players will win big—are you up for the challenge?",
    },
    {
      paragraph:
        "Every Sunday, get a free spin at the Latam1 Wheel of Fortune and grab your chance to win fabulous rewards. As you play, climb through our amazing VIP levels and unlock unmatched perks, making your gaming experience even more special.",
    },
    {
      paragraph:
        "We know you love winning, so we've ensured super-fast awarding of all prizes. Your safety is our priority—our highly secure website protects all your data, giving you peace of mind while you enjoy the fun.",
    },
    {
      paragraph:
        "But that's not all! Enjoy a variety of exciting games, exclusive bonuses, and special events that keep the fun rolling. At Latam1, we bring the thrill and excitement straight to you.",
    },
    {
      paragraph:
        "So, what are you waiting for? Dive into the Latam1 experience today and discover a world of exclusive extras and endless fun!",
    },
  ];

  const [visibleTextCount, setVisibleTextCount] = useState(5);

  const handleShowMore = () => {
    setVisibleTextCount(visibleTextCount + 1);
  };

  useEffect(() => {
    if (window.innerWidth < 768) {
      setVisibleTextCount(2);
    }
  }, []);

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleContent = () => {
    setIsExpanded((prevState) => !prevState);
    // alert(isExpanded);
  };

  return (
    <div className={"homeElementBlock bringOn"}>
      {/* <img
        className="blockBg desktop"
        alt=""
        src={require("assets/lb/images/banners/bring-on-banner.png")}
      />
      <img
        className="blockBg tab"
        alt=""
        src={
          require("assets/lb/images/banners/bring-on-banner-tab.png")
        }
      /> */}
      <div className={"seoContent " + (isExpanded ? "showFull" : "showHalf")}>
        {location.pathname == "/" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Welcome to chilirojo – The Ultimate Online Casino Experience!
            </h1>
            <p className="seo-paragraph">
              Are you ready for non-stop excitement, massive rewards, and an
              unforgettable online gaming experience? <b>chilirojo</b> is your
              premier destination for world-class casino action, featuring{" "}
              <b>5,000+ games</b> from the best providers in the industry.
              Whether you love thrilling <b>slots</b>, electrifying{" "}
              <b>live dealer games</b>, or high-stakes <b>table games</b>, we
              have something for every player!
            </p>
            <h2 className="seo-subtitle">
              5000+ Casino Games – Unlimited Fun!
            </h2>
            <p className="seo-paragraph">
              At chilirojo, you’ll find an incredible selection of games,
              ensuring endless entertainment. Our collection includes:
              <ul>
                <li>
                  <b>Slot Machines</b> – Classic, Video, and Progressive Jackpot
                  Slots
                </li>
                <li>
                  <b>Live Casino</b> – Real Dealers for Roulette, Blackjack,
                  Baccarat & More
                </li>
                <li>
                  <b>Table Games</b> – Poker, Blackjack, Baccarat, Craps, and
                  Sic Bo
                </li>
                <li>
                  <b>Instant Win Games</b> – Scratch Cards, Keno, and Bingo
                </li>
                <li>
                  <b>Provably Fair Games</b> – Crash, Plinko, Dice, and More
                </li>
              </ul>
              With games from top-tier providers, you’ll experience stunning
              graphics, smooth gameplay, and massive winning potential.
            </p>
            <h2 className="seo-subtitle">
              Race Tournaments – Compete & Win Big!
            </h2>
            <p className="seo-paragraph">
              Get ready for high-energy race tournaments where players battle
              for top prizes! Climb the leaderboard, collect points, and unlock
              huge rewards, including cash prizes, free spins, and exclusive
              bonuses. The more you play, the higher your chances of winning!
            </p>
            <h2 className="seo-subtitle">
              VIP Levels – More Rewards, More Benefits!
            </h2>
            <p className="seo-paragraph">
              Loyal players deserve the best, and at chilirojo, our VIP Club
              offers extraordinary perks:
              <ul>
                <li>
                  <b>Exclusive Free Spins & Bonuses</b>
                </li>
                <li>
                  <b>Weekly Cashback Offers</b>
                </li>
                <li>
                  <b>Faster Withdrawals & Higher Limits</b>
                </li>
                <li>
                  <b>Personal VIP Manager</b>
                </li>
                <li>
                  <b>Early Access to New Games</b>
                </li>
                <li>
                  <b>Special Promotions & Birthday Gifts</b>
                </li>
              </ul>
              The higher your VIP level, the more incredible rewards you unlock.
              Start your journey today and reach elite status!
            </p>
            <h2 className="seo-subtitle">
              Mega Welcome Bonus – Up to 200% Bonus + 500 Free Spins!
            </h2>
            <p className="seo-paragraph">
              New players are in for a treat! Our Welcome Package gives you an
              amazing 200% deposit bonus plus up to 500 free spins on top slots.
              This is your perfect chance to boost your bankroll and start
              winning big from day one.
            </p>
            <h2 className="seo-subtitle">The Best (Live) Customer Support</h2>
            <p className="seo-paragraph">
              At chilirojo, we prioritize our players. Our 24/7 live support
              team is always available via live chat and email to assist you
              with any questions or concerns. Experience fast, friendly, and
              professional support whenever you need it!
            </p>
            <h2 className="seo-subtitle">Safe & Secure Gaming</h2>
            <p className="seo-paragraph">
              Your safety is our priority. chilirojo offers secure transactions,
              fast withdrawals, and fair gaming, ensuring a stress-free and
              exciting casino experience. Our platform is fully optimized for
              desktop and mobile, allowing you to play anytime, anywhere.
            </p>
            <h2 className="seo-subtitle">Join chilirojo Today!</h2>
            <p className="seo-paragraph">
              Sign up now and claim your exclusive welcome bonus! With 5,000+
              games, thrilling tournaments, a rewarding VIP program, and
              top-notch support, chilirojo is your ultimate online casino
              destination. Start playing today and hit the jackpot!
            </p>
          </div>
        )}
        {location.pathname == "/promotions" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Experience the Best Promotions at Latam1 Casino!
            </h1>
            <p className="seo-paragraph ">
              At Latam1 Casino, we believe that every player deserves to be
              treated like a VIP. That's why we've designed an unbeatable lineup
              of promotions to make your social gaming experience unforgettable.
              From sign-up bonuses to weekly free spins, our promotions are
              tailored to bring you nonstop excitement and incredible rewards.
            </p>
            <p className="seo-paragraph ">
              <b>Why Our Promotions Shine:</b>
              <ul>
                <li>
                  <b>Welcome Bonuses You'll Love:</b> New to Latam1 Casino? Get
                  started with an exclusive sign-up bonus that sets you up for
                  success. Jump right into the action with free coins and
                  exciting perks—the perfect way to explore our massive game
                  collection.
                </li>
                <li>
                  <b>Daily Free Spins & Rewards:</b> Log in every day to unlock
                  a treasure chest of free spins, coins, and bonus gifts. Each
                  day brings a new surprise, keeping the fun and rewards coming
                  your way!
                </li>
                <li>
                  <b>Exclusive Purchase Promotions:</b> Boost your gaming
                  experience with special deals on coin packages and bonuses.
                  Our limited-time offers give you more value for your money,
                  ensuring endless entertainment and opportunities to win big.
                </li>
                <li>
                  <b>Weekly & Monthly Specials:</b>Stay in the loop for our
                  weekly and monthly promotions. ****From leaderboard challenges
                  to seasonal events, there's always something exciting
                  happening at Latam1 Casino.
                </li>
                <li>
                  <b>Loyalty Rewards You Can't Resist:</b>Climb the ranks of our
                  VIP program and unlock incredible perks as you go. With over
                  40+ rewarding levels, every step takes you closer to bigger
                  prizes, exclusive gifts, and premium bonuses.
                </li>
              </ul>
            </p>
            <p className="seo-paragraph ">Join the Fun Today!</p>
            <p className="seo-paragraph ">
              Don't miss out on the chance to maximize your social casino
              adventure. With Latam1 Casino's thrilling promotions, the rewards
              just keep getting better. Whether you're a seasoned player or a
              newcomer, our offers are designed to make every moment
              extraordinary.
            </p>
            <p className="seo-paragraph ">
              Start spinning, winning, and claiming amazing rewards today. Your
              next big bonus is just around the corner at Latam1 Casino—sign up
              now and experience the thrill!
            </p>
          </div>
        )}
        {location.pathname == "/loyalty-program" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Elevate Your Gaming with Latam1 Casino’s VIP & Loyalty Program!
            </h1>
            <p className="seo-paragraph ">
              At Latam1 Casino, loyalty pays off in extraordinary ways. Our
              exclusive VIP & Loyalty Program is designed to reward your
              dedication with unmatched perks, exciting rewards, and an elevated
              gaming experience. Whether you're spinning reels, tackling table
              games, or exploring our diverse game library, every move brings
              you closer to incredible benefits.
            </p>
            <p className="seo-paragraph ">
              <b>Why Join the VIP & Loyalty Program?</b>
              <ul>
                <li>
                  <b>Earn Rewards as You Play:</b> With every spin, bet, and
                  win, you’re earning points that help you climb through our
                  exciting VIP levels. The higher you go, the bigger the
                  rewards!
                </li>
                <li>
                  <b>Unlock Exclusive VIP Levels:</b> Our program features over
                  40+ levels of rewards, offering increasing benefits at every
                  stage. From free coins and bonus gifts to premium perks,
                  there’s always something to look forward to.
                </li>
                <li>
                  <b>Personalized Perks for Every Player:</b> As a VIP, you’ll
                  enjoy tailored benefits that match your gaming style. Think
                  customized bonus offers, exclusive promotions, and special
                  gifts just for you.
                </li>
                <li>
                  <b>Priority Support:</b>Our VIP members gain access to
                  priority customer support. Need assistance? Our dedicated team
                  is here to make your experience seamless and enjoyable.
                </li>
                <li>
                  <b>Exclusive Events and Challenges: </b>Take part in VIP-only
                  tournaments, leaderboard ****challenges, and seasonal events.
                  Compete with fellow VIPs and win even bigger rewards!
                </li>
                <li>
                  <b>Premium Bonuses and Gifts: </b>Celebrate milestones,
                  holidays, and special occasions with premium bonuses and gifts
                  sent straight to you. Being a VIP means the surprises never
                  stop.
                </li>
              </ul>
            </p>
            <p className="seo-paragraph ">
              Your Journey to VIP Stardom Starts Here
            </p>
            <p className="seo-paragraph ">
              Becoming a VIP at Latam1 Casino is as exciting as it is rewarding.
              Every game you play and every point you earn brings you closer to
              unlocking the ultimate gaming experience. Whether you’re new to
              social gaming or a seasoned pro, our VIP & Loyalty Program is your
              ticket to extraordinary benefits and nonstop fun.
            </p>
            <p className="seo-paragraph ">
              Join today and take your gaming to the next level. Latam1 Casino’s
              VIP & Loyalty Program—where loyalty always wins!
            </p>
          </div>
        )}
        {location.pathname == "/games/all" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Discover Endless Entertainment on the All Games Page at Latam1
              Casino!
            </h1>
            <p className="seo-paragraph ">
              Welcome to the ultimate hub of fun and excitement! At Latam1
              Casino, our All Games category offers a treasure trove of
              thrilling titles designed to suit every player’s taste. Whether
              you’re spinning reels, chasing jackpots, or diving into classic
              table games, there’s something here for everyone.
            </p>
            <p className="seo-paragraph ">
              <b>Explore Our Massive Game Selection:</b>
              <ul>
                <li>
                  <b>Slots Galore: </b> Spin your way to big wins with our
                  extensive collection of slot games. From classic 3-reel slots
                  to immersive video slots packed with bonus features, wilds,
                  and free spins, the possibilities are endless. Don’t miss our
                  games with bonus buy options for instant access to thrilling
                  bonus rounds!
                </li>
                <li>
                  <b>Video Table Games:</b> Love the classics? Enjoy a modern
                  twist on blackjack, roulette, poker, and more with our video
                  table games. With stunning graphics and smooth gameplay, it’s
                  like having a casino at your fingertips.
                </li>
                <li>
                  <b>Megaways™ Games:</b> Experience the excitement of Megaways™
                  slots, where every spin brings thousands of ways to win. These
                  high-energy games offer incredible payouts and nonstop action.
                </li>
                <li>
                  <b>Jackpot Games: </b>Dream big and aim for life-changing wins
                  with our jackpot games. With ****progressive jackpots that
                  grow with every spin, you could be the next lucky winner!
                </li>
                <li>
                  <b>Popular Games: </b>Looking for fan favorites? Check out our
                  curated selection of the most-played and most-loved games at
                  Latam1 Casino. These titles are sure to keep you entertained
                  for hours.
                </li>
                <li>
                  <b>Games with Many Win Lines:</b>: For players who love
                  action-packed gameplay, our games with multiple win lines
                  offer thrilling opportunities to hit big payouts. The more
                  lines, the more ways to win!
                </li>
              </ul>
            </p>
            <p className="seo-paragraph ">
              Why Choose Latam1 Casino’s All Games?
            </p>
            <p className="seo-paragraph ">
              <ul>
                <li>
                  <b>• Over 1,000+ Games:</b> With one of the largest game
                  portfolios in social gaming, you’ll never run out of options.
                </li>
                <li>
                  <b>• Daily Bonuses & Rewards: </b> Log in every day for free
                  coins, spins, and special surprises to keep the fun going.
                </li>
                <li>
                  <b>• High-Quality Entertainment: </b> All our games feature
                  stunning visuals, exciting themes, and smooth gameplay for an
                  unparalleled experience.
                </li>
                <li>
                  <b>• Fun for Everyone: </b> Whether you’re a seasoned player
                  or new to social gaming, you’ll find games to match your skill
                  level and style.
                </li>
              </ul>
            </p>
            <p className="seo-paragraph ">Get Started Today!</p>
            <p className="seo-paragraph ">
              Dive into the world of endless entertainment on the All Games page
              at Latam1 Casino. With so many exciting titles to choose from, the
              next big win is always just a spin away. Sign up now and start
              exploring the ultimate social casino experience!
            </p>
          </div>
        )}
        {location.pathname == "/games/slots" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Spin into Excitement with the Best Slots at Latam1 Casino!
            </h1>
            <p className="seo-paragraph">
              Step into the vibrant world of slot games at Latam1 Casino, where
              every spin promises endless thrills and big rewards. Our Slots
              category is packed with an incredible variety of games, ensuring
              there’s something for everyone—from classic favorites to modern
              masterpieces with jaw-dropping features.
            </p>
            <p className="seo-paragraph">
              <b>Classic & Video Slots:</b> Relive the magic of traditional
              3-reel slots or dive into the immersive experience of video slots
              with stunning graphics, captivating themes, and exciting bonus
              rounds.
            </p>
            <p className="seo-paragraph">
              <b>Bonus Buy Slots:</b> Can’t wait to trigger a bonus round? Our
              Bonus Buy slots let you skip the wait and jump straight into the
              action. Purchase your way to thrilling features and massive wins!
            </p>
            <p className="seo-paragraph">
              <b>Games with Many Win Lines:</b> Multiply your chances of winning
              with our selection of slots featuring multiple win lines. The more
              lines, the more opportunities to hit big payouts.
            </p>
            <p className="seo-paragraph">
              <b>Megaways™ Slots:</b> Experience the innovation of Megaways™
              games, offering thousands of ways to win on every spin. These
              high-energy slots keep the excitement going with unpredictable
              outcomes and incredible potential rewards.
            </p>
            <p className="seo-paragraph">
              <b>****Progressive Jackpots:</b> Dreaming of a life-changing win?
              Our progressive jackpot slots grow with every spin, giving you the
              chance to take home massive prizes. Will you be the next big
              winner?
            </p>
            <p className="seo-paragraph">
              <b>Popular Titles & New Releases:</b> Explore our collection of
              fan-favorite slots and stay ahead of the curve with the latest
              game releases. There’s always something new to try!
            </p>
            <p className="seo-paragraph">
              <b>What Makes Our Slots Stand Out?</b>
            </p>
            <ul>
              <li>
                <b>Diverse Themes:</b> From adventures in ancient Egypt to
                underwater escapades and everything in between, our slot games
                feature themes that cater to all interests.
              </li>
              <li>
                <b>High-Quality Graphics & Sound:</b> Immerse yourself in
                stunning visuals and captivating soundtracks for a truly
                engaging gaming experience.
              </li>
              <li>
                <b>Big Wins & Exciting Features:</b> Enjoy free spins,
                multipliers, wilds, and scatter bonuses that make every spin
                more rewarding.
              </li>
              <li>
                <b>Accessible Fun:</b> Whether you’re a seasoned spinner or a
                first-time player, our slots are easy to play and full of
                opportunities to win.
              </li>
            </ul>
            <p className="seo-paragraph">
              <b>Start Spinning Today!</b>
            </p>
            <p className="seo-paragraph">
              Join Latam1 Casino and explore the best slots in social gaming.
              With so many exciting options and endless chances to win, your
              next big spin is just a click away.
            </p>
          </div>
        )}
        {location.pathname == "/games/table-games" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Master the Classics with Video Table Games at Latam1 Casino!
            </h1>
            <p className="seo-paragraph">
              Step up to the table and enjoy the timeless excitement of video
              table games at Latam1 Casino. Whether you’re a fan of strategy,
              skill, or pure luck, our selection of video table games offers
              something for every kind of player. With modern graphics, smooth
              gameplay, and endless opportunities to win, it’s the ultimate way
              to experience casino classics from the comfort of your home.
            </p>
            <p className="seo-paragraph">
              <b>Explore Our Video Table Games:</b>
            </p>
            <p className="seo-paragraph">
              <b>Blackjack:</b> Beat the dealer and test your strategy in the
              ultimate card game. Whether you’re a seasoned pro or learning the
              ropes, our video blackjack games deliver the perfect mix of
              excitement and rewards.
            </p>
            <p className="seo-paragraph">
              <b>Roulette:</b> Place your bets and spin the wheel in one of the
              most iconic casino games of all time. With various roulette
              variations to choose from, every spin is a chance to win big!
            </p>
            <p className="seo-paragraph">
              <b>Poker:</b> Take your seat at the virtual table and challenge
              your skills with a range of poker games, including Texas Hold’em,
              Caribbean Stud, and more. Bluff, bet, and strategize your way to
              victory.
            </p>
            <p className="seo-paragraph">
              <b>Baccarat:</b> Experience the elegance of baccarat with our
              video version of this classic card game. It’s easy to learn and
              endlessly entertaining, making it a favorite for players of all
              levels.
            </p>
            <p className="seo-paragraph">
              <b>****Craps & Specialty Games:</b> Roll the dice and dive into
              the fast-paced action of video craps or explore other specialty
              table games for a fresh and exciting gaming experience.
            </p>
            <p className="seo-paragraph">
              <b>Why Play Video Table Games at Latam1 Casino?</b>
            </p>
            <ul>
              <li>
                <b>Authentic Casino Feel:</b> Enjoy the look and feel of a real
                casino with high-quality visuals and immersive sound effects.
              </li>
              <li>
                <b>Exciting Variations:</b> From classic versions to modern
                twists, our table games offer endless variety to keep you
                entertained.
              </li>
              <li>
                <b>Fair Play:</b> All games use RNG (Random Number Generator)
                technology to ensure fair outcomes and a trustworthy gaming
                experience.
              </li>
              <li>
                <b>Play at Your Own Pace:</b> No need to rush! Take your time to
                strategize and enjoy each game at your own speed.
              </li>
              <li>
                <b>Daily Rewards & Bonuses:</b> Log in daily to claim coins,
                bonuses, and special rewards to enhance your gaming sessions.
              </li>
            </ul>
            <p className="seo-paragraph">
              <b>Start Your Table Games Adventure Today!</b>
            </p>
            <p className="seo-paragraph">
              Whether you’re chasing a big win or honing your skills, Latam1
              Casino’s video table games deliver endless fun and thrilling
              opportunities. Take your seat at the table—the next big win could
              be yours!
            </p>
          </div>
        )}
        {location.pathname == "/games/new" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Stay Ahead with the Latest Releases in the New Games Category at
              Latam1 Casino!
            </h1>
            <p className="seo-paragraph">
              At Latam1 Casino, the excitement never stops, and there’s always
              something fresh to explore. Our New Games category brings you the
              hottest releases from the past 14 days, ensuring you’re always in
              on the latest action. Be the first to try out cutting-edge games
              packed with innovative features, thrilling themes, and massive win
              potential!
            </p>
            <p className="seo-paragraph">
              <b>Why Play New Games at Latam1 Casino?</b>
            </p>
            <ul>
              <li>
                <b>Fresh Adventures Await:</b> Discover brand-new slots, table
                games, and specialty titles added weekly. Each new game brings a
                unique experience, offering something for every kind of player.
              </li>
              <li>
                <b>Innovative Features:</b> From bonus buy options to cascading
                reels, Megaways™ mechanics, and interactive bonus rounds, our
                new games are designed to keep you entertained like never
                before.
              </li>
              <li>
                <b>Exciting Themes:</b> Step into new worlds with games inspired
                by ancient legends, modern adventures, fantasy realms, and more.
                Each release offers stunning visuals and immersive soundtracks.
              </li>
              <li>
                <b>****Exclusive Promotions:</b> Keep an eye out for special
                bonuses and rewards tied to our new game releases. It’s the
                perfect way to maximize your fun while exploring the latest
                titles.
              </li>
              <li>
                <b>Be the First to Win Big:</b> With every new release, you have
                the chance to score big wins and uncover exciting surprises. Why
                wait when you could be among the first to hit it big?
              </li>
            </ul>
            <p className="seo-paragraph">
              <b>What’s Waiting for You?</b>
            </p>
            <ul>
              <li>
                <b>Hot New Slots:</b> Spin the reels on the latest slot games
                featuring innovative designs, unique mechanics, and countless
                ways to win.
              </li>
              <li>
                <b>Cutting-Edge Table Games:</b> Try the freshest takes on
                classics like blackjack, roulette, and poker, enhanced with
                modern features and gameplay.
              </li>
              <li>
                <b>Specialty Titles:</b> Explore one-of-a-kind games that break
                the mold, offering new ways to play and win.
              </li>
            </ul>
            <p className="seo-paragraph">
              <b>Start Exploring Today!</b>
            </p>
            <p className="seo-paragraph">
              Don’t miss out on the excitement of the New Games category at
              Latam1 Casino. With new titles added every week, there’s always
              something exciting to discover. Sign up now and be the first to
              experience the thrill of the latest releases. Your next big win
              could be waiting in our New Games category!
            </p>
          </div>
        )}
        {location.pathname == "/games/bounus-buy" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Jump Straight to the Action with the Bonus Buy Category at Latam1
              Casino!
            </h1>
            <p className="seo-paragraph">
              Why wait for the excitement to build when you can take control and
              dive right into the most thrilling parts of your favorite games?
              At Latam1 Casino, our Bonus Buy category lets you skip the wait
              and unlock bonus rounds, free spins, and special features
              instantly. It’s the perfect choice for players who love nonstop
              action and incredible rewards.
            </p>
            <p className="seo-paragraph">
              <b>What is the Bonus Buy Category?</b>
            </p>
            <p className="seo-paragraph">
              The Bonus Buy category features games that let you purchase direct
              access to their most exciting features. Whether it’s a free spins
              round, bonus multipliers, or jackpot opportunities, you can jump
              straight to the heart of the action without waiting for the reels
              to align.
            </p>
            <p className="seo-paragraph">
              <b>Why Choose Bonus Buy Games at Latam1 Casino?</b>
            </p>
            <ul>
              <li>
                <b>Instant Gratification:</b> Say goodbye to waiting and hello
                to instant excitement! Trigger bonus rounds and features
                whenever you’re ready.
              </li>
              <li>
                <b>Maximize Your Wins:</b> Bonus rounds often come with higher
                win potential, multipliers, and unique gameplay elements that
                make every spin more rewarding.
              </li>
              <li>
                <b>Diverse Game Selection:</b> From thrilling slots to
                innovative specialty games, our Bonus Buy category is packed
                with titles that cater to every style of play.
              </li>
              <li>
                <b>Control Your Experience:</b> Take charge of your gaming
                session by choosing when and how to activate the game’s most
                exciting features.
              </li>
              <li>
                <b>Exciting Themes & Features:</b> From adventure and fantasy to
                classic casino vibes, our Bonus Buy games are loaded with
                stunning visuals, immersive soundtracks, and innovative
                mechanics.
              </li>
            </ul>
            <p className="seo-paragraph">
              <b>How Does Bonus Buy Work?</b>
            </p>
            <ul>
              <li>
                <b>Select Your Game:</b> Browse the Bonus Buy category and pick
                a game that catches your eye.
              </li>
              <li>
                <b>Activate the Bonus Feature:</b> Use the Bonus Buy option to
                instantly unlock the game’s special features or bonus round.
              </li>
              <li>
                <b>Enjoy the Action:</b> Dive into the excitement and watch as
                the rewards roll in!
              </li>
            </ul>
            <p className="seo-paragraph">
              <b>Start Playing Bonus Buy Games Today!</b>
            </p>
            <p className="seo-paragraph">
              Ready to take your gaming to the next level? Explore the Bonus Buy
              category at Latam1 Casino and enjoy instant access to thrilling
              features and massive win potential. Don’t wait for the fun—create
              it! Sign up now and start spinning your way to incredible rewards.
            </p>
          </div>
        )}
        {location.pathname == "/games/crash-games" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Feel the Adrenaline with Crash Games at Latam1 Casino!
            </h1>
            <p className="seo-paragraph">
              Get ready for heart-pounding action with <b>Crash Games</b> at{" "}
              <b>Latam1 Casino</b>! Perfect for thrill-seekers and players who
              love high-stakes excitement, Crash Games deliver a unique gaming
              experience where <b>timing is everything</b>. Test your instincts
              and nerves as you aim to cash out before the multiplier
              crashes—the longer you hold on, the <b>bigger the reward</b>!
            </p>

            <p className="seo-paragraph">
              <b>What Are Crash Games?</b>
            </p>
            <p className="seo-paragraph">
              Crash Games are <b>fast-paced, high-energy</b> games where you
              watch a multiplier climb higher and higher. The challenge?{" "}
              <b>Decide when to cash out before it crashes</b>. It’s all about{" "}
              <b>strategy, timing, and a touch of daring</b>—making every round
              as exciting as the last.
            </p>

            <p className="seo-paragraph">
              <b>Why Play Crash Games at Latam1 Casino?</b>
            </p>
            <ul>
              <li>
                <b> Fast-Paced Fun:</b> Perfect for players who crave quick,{" "}
                <b>thrilling gameplay</b> with endless opportunities to win big.
              </li>
              <li>
                <b> Easy to Play:</b> With <b>simple mechanics</b> and intuitive
                controls, you can dive straight into the action—no prior
                experience needed!
              </li>
              <li>
                <b> High Rewards:</b> The <b>multiplier increases rapidly</b>,
                giving you the chance to score <b>massive payouts</b> if you
                time your cash-out perfectly.
              </li>
              <li>
                <b> Strategic Gameplay:</b> Test your{" "}
                <b>skills and decision-making</b> as you try to balance{" "}
                <b>risk and reward</b>. Will you play it safe or go for the
                biggest multiplier?
              </li>
              <li>
                <b> Engaging Visuals & Themes:</b> Enjoy{" "}
                <b>stunning graphics</b> and <b>dynamic animations</b> that
                bring every round to life, keeping you on the{" "}
                <b>edge of your seat</b>.
              </li>
            </ul>

            <p className="seo-paragraph">
              <b>How to Play Crash Games:</b>
            </p>
            <ul>
              <li>
                <b>1️ Place Your Bet:</b> Choose how much you want to wager for
                the round.
              </li>
              <li>
                <b>2️ Watch the Multiplier Climb:</b> The multiplier starts to
                rise, and so does the excitement.
              </li>
              <li>
                <b>3️ Decide When to Cash Out:</b> Click the{" "}
                <b>cash-out button</b> before the multiplier crashes. The longer
                you wait, the <b>bigger your potential reward</b>—but don’t wait
                too long!
              </li>
            </ul>

            <p className="seo-paragraph">
              <b>Why Latam1 Casino?</b>
            </p>
            <ul>
              <li>
                <b> Exciting Game Selection:</b> Our <b>Crash Games</b> category
                features a variety of thrilling options to keep you entertained.
              </li>
              <li>
                <b> Fair Play Guarantee:</b> All games use{" "}
                <b>RNG (Random Number Generator) technology</b> to ensure
                fairness and transparency.
              </li>
              <li>
                <b> Daily Bonuses & Rewards:</b> Boost your gameplay with{" "}
                <b>free coins, spins, and special bonuses</b> available every
                day.
              </li>
            </ul>

            <p className="seo-paragraph">
              <b>Start Playing Crash Games Today!</b>
            </p>
            <p className="seo-paragraph">
              Dive into the <b>adrenaline-filled world of Crash Games</b> at
              Latam1 Casino. Whether you’re a <b>seasoned pro</b> or a{" "}
              <b>first-time player</b>, the <b>excitement and rewards</b>
              are waiting for you. See how high you can go before the{" "}
              <b>crash</b>—your <b>next big win</b> is just a click away!
            </p>
          </div>
        )}
        {location.pathname == "/games/popular" && (
          <div className="homeBlockContent">
            <h1 className="seo-title">
              Play the Fan Favorites in the Popular Games Category at Latam1
              Casino!
            </h1>
            <p className="seo-paragraph">
              Looking for games that players just can’t get enough of? You’ve
              come to the right place! The <b>Popular Games</b> category at{" "}
              <b>Latam1 Casino</b> features a <b>handpicked collection</b>
              of the most-loved titles across all gaming styles. These games
              have captured the hearts of our community, and now it’s your turn
              to see what all the excitement is about!
            </p>

            <p className="seo-paragraph">
              <b>Why Choose Popular Games at Latam1 Casino?</b>
            </p>
            <ul>
              <li>
                <b>Tried-and-True Favorites:</b> Explore a curated selection of
                games that consistently deliver <b>excitement, big wins,</b> and
                unforgettable gameplay.
              </li>
              <li>
                <b>Diverse Selection:</b> From thrilling <b>slots</b> and
                classic <b>table games</b> to <b>jackpot</b> games and specialty
                titles, our Popular Games category has something for everyone.
              </li>
              <li>
                <b>Proven Fun:</b> These games are <b>popular for a reason!</b>{" "}
                Enjoy engaging features, stunning visuals, and rewarding
                mechanics that keep players coming back for more.
              </li>
              <li>
                <b>Big Win Potential:</b> Many of our popular games offer{" "}
                <b>incredible payouts, multipliers,</b> and <b>bonus rounds</b>,
                giving you more chances to score big.
              </li>
              <li>
                <b>Community Favorites:</b> Join the <b>Latam1 Casino</b>{" "}
                community and enjoy the games that have become instant classics
                among players worldwide.
              </li>
            </ul>

            <p className="seo-paragraph">
              <b>What Can You Expect?</b>
            </p>
            <ul>
              <li>
                <b>Top Slots:</b> Spin the reels on crowd-pleasing{" "}
                <b>slot games</b> packed with exciting themes, free spins, and{" "}
                <b>bonus buy</b> features.
              </li>
              <li>
                <b> Table Games:</b> Play classic{" "}
                <b>blackjack, roulette, poker,</b> and more with games that
                deliver the perfect blend of <b>strategy and fun.</b>
              </li>
              <li>
                <b> Jackpot Hits:</b> Try your luck at games with{" "}
                <b>life-changing jackpots</b> that could turn your next spin
                into a massive win.
              </li>
              <li>
                <b> Specialty Games:</b> Dive into <b>unique and innovative</b>{" "}
                titles that break the mold and keep the excitement fresh.
              </li>
            </ul>

            <p className="seo-paragraph">
              <b>Why Play at Latam1 Casino?</b>
            </p>
            <ul>
              <li>
                <b> Unmatched Variety:</b> Our <b>Popular Games</b> category is
                regularly updated to feature the <b>best and most exciting</b>{" "}
                titles.
              </li>
              <li>
                <b> Daily Rewards & Bonuses:</b> Keep the fun going with{" "}
                <b>free coins, spins,</b> and special promotions available every
                day.
              </li>
              <li>
                <b> Safe & Secure:</b> Enjoy a <b>gaming environment</b>{" "}
                designed for your safety and entertainment.
              </li>
            </ul>

            <p className="seo-paragraph">
              <b>Join the Fun Today!</b>
            </p>
            <p className="seo-paragraph">
              Don’t miss out on the excitement of our <b>Popular Games</b>{" "}
              category at <b>Latam1 Casino</b>. These <b>fan-favorite titles</b>{" "}
              are guaranteed to provide <b>endless entertainment</b> and winning
              opportunities. Start playing now and see why these games are{" "}
              <b>loved by players everywhere!</b>
            </p>
          </div>
        )}

        <button
          hreflang={Translator.getSelectedLanguage().code}
          onClick={toggleContent}
          className="commonBtn moreLessBtn pOneBtn"
        >
          <span className="front">
            {isExpanded ? "Show Less" : "Show More"}
          </span>
        </button>
      </div>
    </div>
  );
}
